



import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class CardHeader extends Vue {
  @Prop({required: true, type: String, default: ''}) title !: string
  @Prop(String) subTitle ?: string

  private get text(): string {
    if (!this.title) return ''
    return this.title
  }

  private get subTitleText(): string {
    if (!this.subTitle) return ''
    return this.subTitle
  }
}
